/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_card_account_balance_summary_tabs_usd = /** @type {(inputs: {}) => string} */ () => {
	return `Dólar`
};

const en_card_account_balance_summary_tabs_usd = /** @type {(inputs: {}) => string} */ () => {
	return `Dollar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const card_account_balance_summary_tabs_usd = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_account_balance_summary_tabs_usd(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_account_balance_summary_tabs_usd", locale)
	if (locale === "es") return es_card_account_balance_summary_tabs_usd(inputs)
	return en_card_account_balance_summary_tabs_usd(inputs)
};
export { card_account_balance_summary_tabs_usd as "card.account_balance_summary.tabs.usd" }